<template>
    <div>
        <v-layout wrap align-center justify-space-between
                  class="mb-4" :class="{'mx-3': $vuetify.breakpoint.xs}"
        >
            <v-flex sm6 xs12 class="display-1 pr-4">{{$t("Комментарии")}} ({{ comments.length || 0 }})</v-flex>
            <v-layout class="justify-end" :class="{'mt-3': $vuetify.breakpoint.xs}">
                <buttonRed :class="{'flex xs12': $vuetify.breakpoint.smAndDown}" @click.native.self="OPEN_MODAL('add_comment_modal')">{{$t("Оставить комментарий")}}</buttonRed>
            </v-layout>
        </v-layout>
        <div class="news_comments-wrap mb-4">
            <NewsComment v-for="(item, index) in comments_paginated" :key="index" :class="{'background-light': !(index%2)}"
                         :content="item"
            />
        </div>
        <v-layout v-if="comments.length > 10" mb-5 mt-4
                  justify-space-between
                  align-center wrap text-sm-left
                  text-xs-center
                  :class="{'px-3': $vuetify.breakpoint.xs}"
        >
            <v-flex md3 sm6
                    mb-4
                    :class="{'layout': $vuetify.breakpoint.xs}"
            >
                <buttonRed :class="{'flex xs12': $vuetify.breakpoint.xs}" @click.native="OPEN_MODAL('add_comment_modal')">{{$t("Оставить комментарий")}}</buttonRed>
            </v-flex>
            <v-flex lg4 md5 sm6
                    xs12 mb-4
            >
                <div class="text-xs-center text-sm-left">
                    <v-pagination
                        v-model="page"
                        :length="Math.ceil(comments.length / selected_number)"
                        :total-visible="$vuetify.breakpoint.smAndDown ? 4 : 6"
                        prev-icon="arrow_back_ios"
                        next-icon="arrow_forward_ios"
                    />
                </div>
            </v-flex>
            <v-flex md4 sm6 mb-4>
                <v-select
                    v-model="listSize"
                    :items="$vuetify.breakpoint.mdAndUp ?
                      [
                        {
                          text: $t('Показывать по 10'),
                          value: 'Показывать по 10',
                        },
                        {
                          text: $t('Показывать по 25'),
                          value: 'Показывать по 25',
                        },
                        {
                          text: $t('Показывать по 50'),
                          value: 'Показывать по 50',
                        },
                        {
                          text: $t('Показывать по 100'),
                          value: 'Показывать по 100',
                        },
                      ]
                      :
                      [
                        {
                          text: $t('Показывать по 10'),
                          value: 'Показывать по 10',
                        },
                        {
                          text: $t('Показывать по 25'),
                          value: 'Показывать по 25',
                        },
                        {
                          text: $t('Показывать по 50'),
                          value: 'Показывать по 50',
                        },
                      ]"
                    solo
                    append-icon=""
                    class="input"
                    @change="changeListSize($event)"
                >
                  <template #append>
                    <v-icon aria-hidden="true" translate="no">
                      expand_more
                    </v-icon>
                  </template>
                </v-select>
            </v-flex>
        </v-layout>

        <v-dialog v-model="modal_comment_edit" :width="$vuetify.breakpoint.mdAndUp ? 1100 : 'auto'" persistent>
            <newsCommentModalEdit />
        </v-dialog>
    </div>
</template>

<script>
import buttonRed   from '@/components/ui/buttons/button_red';
import newsCommentModalEdit from './News_modals/news_comment_modal_edit';
import NewsComment from './news_comment_block';
import {mapGetters, mapMutations, mapActions} from 'vuex';
import dayjs from 'dayjs';

export default {
  components: {
    buttonRed,
    newsCommentModalEdit,
    NewsComment,
  },
  props: {
    content: {
      type: Array,
    },
  },
  data() {
    return {
      listSize: 'Показывать по 10',
    };
  },
  computed: {
    page: {
      get() {
        return this.selected_page;
      },
      set($event) {
        return this.SET_SELECTED_PAGE($event);
      },
    },
    ...mapGetters('profile/user', [
      'user',
    ]),
    ...mapGetters('news_main/detail', ['comments', 'modal_comment_edit', 'add_comment_modal', 'selected_number', 'selected_page', 'comments_paginated']),
  },
  methods: {
    ...mapActions('news_main/detail', ['show_number']),
    ...mapMutations('news_main/detail', [
      'OPEN_MODAL',
      'CLOSE_MODAL',
      'SET_SELECTED_PAGE',
      'SET_EDITED_ID',
      'SET_COMMENTS',
    ]),
    changeListSize(nextSize) {
      this.show_number(nextSize);
    },
  },

};
</script>
